// Measures the header icons box for the menu-cart "growing box" morph
// (see elementor-widgets/_son-menu-cart.scss): the closed panel needs the
// box's real border-box size, the open one the real contents height.

function bindHeaderActions(box) {
    if (box.dataset.sonCartMeasured) {
        return;
    }
    box.dataset.sonCartMeasured = 'true';

    const apply = () => {
        box.style.setProperty('--son-cart-box-w', `${box.offsetWidth}px`);
        box.style.setProperty('--son-cart-box-h', `${box.offsetHeight}px`);
    };

    new ResizeObserver(apply).observe(box);
    apply();

    // open height = box + contents, so the height animation ends exactly where the panel does;
    // contents are capped to the room left below the box (the product list scrolls)
    const widget = box.querySelector('.elementor-widget-woocommerce-menu-cart');
    const main = box.querySelector('.elementor-menu-cart__main');
    if (!widget || !main) {
        return;
    }
    const measureOpen = () => {
        const room = window.innerHeight - box.getBoundingClientRect().bottom - 16;
        box.style.setProperty('--son-cart-main-max', `${Math.max(160, Math.min(520, room))}px`);
        box.style.setProperty('--son-cart-open-h', `${box.offsetHeight + main.offsetHeight}px`);
    };

    new ResizeObserver(measureOpen).observe(main); // cart fragments refresh the contents
    new MutationObserver(measureOpen).observe(widget, { attributes: true, attributeFilter: ['class'] }); // on open: header may have scrolled
    window.addEventListener('resize', measureOpen);
    measureOpen();

    // Keyboard. Elementor only fades the closed panel out (and it sits before
    // the toggle in the DOM), so its product, remove and checkout links were Tab
    // stops while invisible: inert while closed. Opened from the toggle, focus
    // moves to the first link in the panel; closing with focus inside (Escape)
    // hands it back to the toggle.
    const container = widget.querySelector('.elementor-menu-cart__container');
    const isShown = () => widget.classList.contains('elementor-menu-cart--shown');
    let wasShown = isShown();
    if (container) {
        container.inert = !wasShown;
    }
    new MutationObserver(() => {
        const shown = isShown();
        if (shown === wasShown) {
            return;
        }
        wasShown = shown;
        if (container) {
            container.inert = !shown;
        }

        const toggle = widget.querySelector('.elementor-menu-cart__toggle_button');
        if (shown && document.activeElement === toggle) {
            // first rendered link - the thumbnail link is display:none in this design
            [...main.querySelectorAll('a[href], button:not([disabled])')].find((el) => el.getClientRects().length)?.focus();
        } else if (!shown && main.contains(document.activeElement)) {
            toggle?.focus();
        }
    }).observe(widget, { attributes: true, attributeFilter: ['class'] });
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.son-header-actions').forEach(bindHeaderActions);
});

// the editor renders the header after DOMContentLoaded, so bind again per element
window.addEventListener('elementor/frontend/init', () => {
    if (window.elementorFrontend && window.elementorFrontend.hooks) {
        window.elementorFrontend.hooks.addAction('frontend/element_ready/global', ($element) => {
            const el = $element[0];
            const box = el && el.closest('.son-header-actions');
            if (box) {
                bindHeaderActions(box);
            }
            el?.querySelectorAll?.('.son-header-actions').forEach(bindHeaderActions);
        });
    }
});
